/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Note_3_TitleInputs */

const en_homepage_features_note_3_title = /** @type {(inputs: Homepage_Features_Note_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organised Notes`)
};

const es_homepage_features_note_3_title = /** @type {(inputs: Homepage_Features_Note_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas organizadas`)
};

/**
* | output |
* | --- |
* | "Organised Notes" |
*
* @param {Homepage_Features_Note_3_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_note_3_title = /** @type {((inputs?: Homepage_Features_Note_3_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Note_3_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_note_3_title(inputs)
	return en_homepage_features_note_3_title(inputs)
});